import React from 'react';

const DownChartIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16 17H22M22 17V11M22 17L13.5 8.5L8.5 13.5L2 7'
        stroke='#FF0500'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default DownChartIcon;
